import { SelectorRowStates } from '../../../../../../components/selectorRowV2/types/state';
import { TextVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
import { SelectorRowVariants } from '../variants';
export const getToggleTitleDescriptionStyles = (FOUNDATIONS, FONT) => ({
    // What changes in this variant is the background color when selected, and the alignment of decorative element and toggle
    [SelectorRowVariants.WITH_TOGGLE_TITLE_DESCRIPTION]: {
        [SelectorRowStates.UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
            }),
        },
        [SelectorRowStates.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
            }),
        },
        [SelectorRowStates.HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
            }),
        },
        [SelectorRowStates.PRESSED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
            }),
        },
        [SelectorRowStates.FILLING]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
            }),
        },
        // In Design, this variant only has a general disabled style
        [SelectorRowStates.DISABLED_UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
        [SelectorRowStates.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    align_items: 'flex-start',
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_100,
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                description: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
    },
});
//# sourceMappingURL=toggleTitleDescription.js.map